/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// todo 写页面样式的时候,调完pc端样式,移动端还要调式,移动端样式和pc端可能完全不同.
import Vue from 'vue'
import App from './App.vue'

import i18n, { initializeLocale, getLocaleNativeName } from './lang' // Internationalization

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// Vue.use(Vuesax);


// import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/eleThemeChange.scss'; // 修改element-ui的主题色


// 修改element-ui的样式的
import './assets/scss/element.scss'
//指令
import '@/directive/emoji.js';
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);
//element 按需引入,需要用组件先引入

import {
  Tooltip,
  Form,
  FormItem,
  Image,
  Tree,
  Input,
  Select,
  Option,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Rate,
  Carousel,
  CarouselItem,
  Upload,
  Table,
  TableColumn,
  DatePicker,
  Dialog,
  TimeSelect,
  TimePicker,
  Popover,
  Progress,
  Checkbox,
  CheckboxGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Divider,
  Drawer,
  Radio,
  Button,
  Loading,
  Message,
  MessageBox,
  Switch,
  Scrollbar
} from 'element-ui';

let i18nObj = {
  i18n: (key, value) => i18n.t(key, value)
}

function getLocaleLabel(locale) {
  return getLocaleNativeName(locale)
}

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, char => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]))
}

function getHighlightedLocaleLabel(locale) {
  return `<strong style="color: #409EFF; font-weight: 600;">${escapeHtml(getLocaleLabel(locale))}</strong>`
}

function getLocaleConfirmOptions(currentLocale, targetLocale, geo) {
  const targetLabel = getLocaleLabel(targetLocale)

  return {
    title: i18n.t('autoLocale.switchTitle'),
    message: i18n.t('autoLocale.switchMessage', {
      target: getHighlightedLocaleLabel(targetLocale)
    }),
    confirmButtonText: i18n.t('autoLocale.switchConfirm', {
      target: targetLabel
    }),
    cancelButtonText: i18n.t('autoLocale.switchCancel')
  }
}

Vue.use(Tooltip,i18nObj);
Vue.use(Form,i18nObj);
Vue.use(FormItem,i18nObj);
Vue.use(Image,i18nObj);
Vue.use(Tree,i18nObj);
Vue.use(Input,i18nObj);
Vue.use(Select,i18nObj);
Vue.use(Option,i18nObj);
Vue.use(Row,i18nObj);
Vue.use(Col,i18nObj);
Vue.use(Collapse,i18nObj);
Vue.use(CollapseItem,i18nObj);
Vue.use(Rate,i18nObj);
Vue.use(Carousel,i18nObj);
Vue.use(CarouselItem,i18nObj);
Vue.use(Upload,i18nObj);
Vue.use(Table,i18nObj);
Vue.use(TableColumn,i18nObj);
Vue.use(DatePicker,i18nObj);
Vue.use(Divider,i18nObj);
Vue.use(TimeSelect,i18nObj);
Vue.use(TimePicker,i18nObj);
Vue.use(Popover,i18nObj);
Vue.use(Progress,i18nObj);
Vue.use(Checkbox,i18nObj);
Vue.use(CheckboxGroup,i18nObj);
Vue.use(Dropdown,i18nObj);
Vue.use(DropdownMenu,i18nObj);
Vue.use(DropdownItem,i18nObj);
Vue.use(Drawer,i18nObj);
Vue.use(Radio,i18nObj);
Vue.use(Button,i18nObj);
/*Vue.use(Message); Message和MessageBox不用use
Vue.use(MessageBox);*/
Vue.use(Switch,i18nObj);
Vue.use(Scrollbar,i18nObj);
Vue.use(Dialog,i18nObj);
Vue.use(Loading.directive,i18nObj);

Vue.prototype.$loading = Loading.service;
// $loading,$msgbox,$message 不是user而是加入到prototype原型中
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

import { Calendar } from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';
Vue.use(Calendar);

import selectDateDuration from './components/common/mobile/selectDateDuration';
Vue.component('select-date-duration',selectDateDuration);

// axios
import request from '@/utils/ajax';
Vue.prototype.$http = request;

import config from '@/utils/globalConfig';
Vue.prototype.$config = config;

import { uploadFile } from "@/utils/uploadFile";
import { getBase64,base64toFile } from "@/utils/common";
import { initUniBridge, getIsUniAppWebView, getIsMobile } from "@/utils/uni-bridge";
Vue.prototype.$uploadFile = uploadFile;
Vue.prototype.$getBase64 = getBase64;
Vue.prototype.$base64toFile = base64toFile;
Vue.prototype.$isUniApp = getIsUniAppWebView;
Vue.prototype.$isMobile = getIsMobile;

import md5 from "js-md5";
Vue.prototype.$md5 = md5;

import oss from "@/utils/oss.js";
Vue.prototype.$oss = oss;

// Vuesax安装
// Theme Configurations
import '../themeConfig.js'


import _ from 'lodash';//global lodash
// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router/router'

// Vuex Store
import store from './store/index'



// VeeValidate
// import VeeValidate from 'vee-validate';
// Vue.use(VeeValidate);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import './assets/libraryCss/quill_base.css' // quill富文本编辑器

// Feather font icon
// require('./assets/css/iconfont.css') // 不引用,因自己有阿里的iconfont
// 下载引入自己的iconfont todo

import '@/assets/iconfont/iconfont.css'       // 用了两个iconfont项目,一个是彩色图标,一个环楚crm


// 一些在各种媒体查询下的显示隐藏类
import '@/assets/scss/media.scss'
//修改vuesax 组件的样式
import '@/assets/scss/vuesaxChange.scss'
//公共样式
import '@/assets/scss/public.scss'

// 地区插件 todo 需要显示国家的
import 'vue-area-linkage/dist/index.css'; // v2 or higher
import VueAreaLinkage from 'vue-area-linkage';

Vue.use(VueAreaLinkage);



Vue.config.productionTip = false

async function startApp() {
  await initUniBridge();

  // 初始化语言（可能等待最多 3s IP 检测）
  await initializeLocale({
    detectGeo: () => request({
      url: '/crm/reception/ipGeo',
      method: 'get'
    }).then(res => res.data),
    respectPrivacy: true,
    confirmLocaleChange: ({ currentLocale, targetLocale, geo }) => {
      const options = getLocaleConfirmOptions(currentLocale, targetLocale, geo)
      return MessageBox.confirm(options.message, options.title, {
        confirmButtonText: options.confirmButtonText,
        cancelButtonText: options.cancelButtonText,
        dangerouslyUseHTMLString: true,
        type: 'info'
      }).then(() => true).catch(() => false)
    },
    onLocaleChange: language => {
      store.dispatch('setLanguage', language)
      window.location.reload()
    }
  })

  // 同步 Vuex 语言状态与 i18n.locale
  store.dispatch('setLanguage', i18n.locale)
  await store.dispatch('loadSmsVerificationEnabled')

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

startApp()
